import {Component, Input, OnInit} from '@angular/core';
import {UserService} from '../../../../services/user-services/user.service';
import {Router} from '@angular/router';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { AuthenticationService } from 'src/app/services/authentication.service';
//import { MetaService } from 'src/app/services/meta.service';
import { NgClass, NgFor } from '@angular/common';
import {HelperService} from "../../../../services/helper.service";

@Component({
  selector: 'app-hc-home',
  templateUrl: './hc-home.component.html',
  styleUrls: ['./hc-home.component.scss'],
  standalone: true,
  imports: [NgClass, NgFor, TranslateModule]
})
export class HcHomeComponent implements OnInit {

  @Input() process;
  @Input() forcePage;
  isMobile = false;

  constructor(
    private userService : UserService,
    private router: Router,
    private translateService: TranslateService,
    private authenticationService: AuthenticationService,
    private helperService: HelperService,

  ) { }

  ngOnInit(): void {
    this.isMobile = this.userService.isMobileUser;
    if (this.authenticationService.currentUserValue) {
      let hubspotDatas = {
        campagne: '',
        source: '',
        medium: ''
      };
      hubspotDatas = this.helperService.setUtmToHubspot(hubspotDatas);
      this.userService.setHubspotDeal(6459040, 19276177, hubspotDatas).subscribe();
    }
    const currentUser = this.userService.getInfos();
    //this.metaService.sendPageView('ViewHC',this.router.url,currentUser ? currentUser.id : 0,0,'hc').subscribe();
  }

  goNext() {
    this.router.navigate(
      [this.translateService.currentLang + '/housing-certificate/informations'],
      { queryParams: { force: this.forcePage } }
    );
  }

  goTo() {
    if (this.process) {
      if (this.translateService.currentLang == 'fr') {
        window.open('https://help.livin-france.com/knowledge/' + this.process?.helpcenterLinkFR, '_blank', 'noopener,noreferrer');
      } else {
        window.open('https://help.livin-france.com/en/knowledge/' + this.process?.helpcenterLink, '_blank', 'noopener,noreferrer');
      }
    } else {
      window.open('https://help.livin-france.com/en/knowledge/i-need-accommodation-certificate-how-can-i-get-one', '_blank', 'noopener,noreferrer')
    }
  }

}
